import React from 'react';
import { IonCard, IonCardContent, IonCardHeader, IonText, IonChip, IonLabel, IonAvatar } from '@ionic/react';

import '../../styles/home/Trending.scss';

const formatTimestamp = timestamp => {
  const date = new Date(parseInt(timestamp, 10));
  const now = new Date();
  const diffInMilliseconds = now - date;
  const diffInHours = diffInMilliseconds / (1000 * 60 * 60);
  const diffInMinutes = diffInMilliseconds / (1000 * 60);

  if (date.toDateString() === now.toDateString()) {
    if (diffInMinutes < 60) {
      const minutes = Math.floor(diffInMinutes);
      return `${minutes} ${minutes === 1 ? 'minute' : 'minutes'} ago`;
    }
    const hours = Math.floor(diffInHours);
    return `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;
  }

  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const year = date.getFullYear().toString().slice(-2);
  return `${month}/${day}/${year}`;
};

const TrendingCard = ({ item }) => (
  <IonCard className='trending-card'>
    <IonCardHeader className='trending-card-header'>
      <div className='trending-header-content'>
        <div className='trending-profile'>
          <IonAvatar className='trending-avatar'>
            <img src={item.profile_image_url} alt={item.screen_name} />
          </IonAvatar>
          <div className='trending-user-info'>
            <IonText className='trending-username'>
              <strong>{item.screen_name}</strong>
              <span className='trending-handle'>@{item.username}</span>
            </IonText>
          </div>
        </div>
        <div className='trending-meta'>
          <IonChip color='primary' className='trending-league-tag'>
            <IonLabel>
              {item.league_map === 'Uncategorized' || !item.league_map || item.league_map === 'undefined'
                ? 'Sports'
                : item.league_map}
            </IonLabel>
          </IonChip>
          <IonText className='trending-timestamp' color='medium'>
            {formatTimestamp(item.published_timestamp)}
          </IonText>
        </div>
      </div>
    </IonCardHeader>
    <IonCardContent>
      <p className='trending-text'>{item.text_body}</p>
      {item.content_type === 'video' && item.video_url && (
        <div className='trending-video-container'>
          <video
            controls
            className='trending-video'
            preload='metadata'
            poster={item.image_url || undefined}
            style={{
              width: '100%',
              maxHeight: '400px',
              objectFit: 'contain',
              backgroundColor: '#000',
            }}>
            <source src={item.video_url} type='video/mp4' />
            <track kind='captions' src='' label='English' />
            Your browser does not support the video tag.
          </video>
        </div>
      )}
      {(item.content_type === 'photo' || item.image_url) && (
        <div className='trending-image-container'>
          <img src={item.image_url} alt={item.text_body} className='trending-image' />
        </div>
      )}
    </IonCardContent>
  </IonCard>
);

export default TrendingCard;
